import React from "react";
import ConfigRouter from "./ConfigRouter";
import LoadingIndicator from "./globals/Components/Loading/LoadingIndicator";
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import * as pdfjsLib from 'pdfjs-dist';
import HelmetIndex from "./globals/HelmetIndex/HelmetIndex";


// Configurar la ubicación del worker
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

class App extends React.Component {
  render() {
    return (
      <>
        <ConfigProvider locale={esES}>
        <HelmetIndex />
          <ConfigRouter />
          <LoadingIndicator />
        </ConfigProvider>

      </>
    );
  }
}
export default App;